import React from 'react'
import IconPng from 'atoms/IconPng'
import { IconWrapper } from './styles'

const Btn = ({ icon, fn }) => {
  return (
    <IconWrapper onClick={() => fn()}>
      <IconPng srcIcon={icon} ml={'0'} size={'auto'} h={'24'} showPointer={true} />
    </IconWrapper>
  )
}

export default Btn
